import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getExternalLinkSaga(action: types.GetExternalLinkActionType) {
  try {
    const response = yield call(
      services.getExternalLinkService,
      action.payload
    );
    yield put({
      type: actions.GET_EXTERNAL_LINK_SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: actions.GET_EXTERNAL_LINK_ERROR,
      error,
    });
    toastr.error("External Links Not Loaded", `${error.error.message}`);
  }
}

export function* getExternalLinksSaga(
  action: types.GetExternalLinksActionType
) {
  try {
    const response = yield call(
      services.getExternalLinksService,
      action.payload
    );
    yield put({
      type: actions.GET_EXTERNAL_LINKS_SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: actions.GET_EXTERNAL_LINKS_ERROR,
      error,
    });
    toastr.error("External Links Not Loaded", `${error.error.message}`);
  }
}

export function* addExternalLinkSaga(action: types.AddExternalLinkActionType) {
  try {
    const addResponse = yield call(
      services.addExternalLinkService,
      action.payload
    );
    const getResponse = yield call(services.getExternalLinksService);
    if (addResponse.data) {
      yield put({
        type: actions.ADD_EXTERNAL_LINK_SUCCESS,
        response: addResponse,
      });
      yield put({
        type: actions.GET_EXTERNAL_LINKS_SUCCESS,
        response: getResponse,
      });
      toastr.success("External Link Added", `Added a new link`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({
      type: actions.ADD_EXTERNAL_LINK_ERROR,
      error,
    });
    toastr.error("External Link Not Created", `${error.error.message}`);
  }
}

export function* modifyExternalLinkSaga(
  action: types.ModifyExternalLinkActionType
) {
  try {
    const modifyResponse = yield call(
      services.modifyExternalLinkService,
      action.payload
    );
    const getResponse = yield call(services.getExternalLinksService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_EXTERNAL_LINK_SUCCESS,
        response: modifyResponse,
      });
      yield put({
        type: actions.GET_EXTERNAL_LINKS_SUCCESS,
        response: getResponse,
      });
      toastr.success("External Link Modified", `Success`);
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({
      type: actions.MODIFY_EXTERNAL_LINK_ERROR,
      error,
    });
    toastr.error("External Link Not Modified", `${error.error.message}`);
  }
}

export function* deleteExternalLinkSaga(
  action: types.DeleteExternalLinkActionType
) {
  try {
    const deleteResponse = yield call(
      services.deleteExternalLinkService,
      action.payload
    );
    const getResponse = yield call(services.getExternalLinksService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_EXTERNAL_LINK_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_EXTERNAL_LINKS_SUCCESS,
        response: getResponse,
      });
      toastr.success("External Link Deleted", `Success`);
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({
      type: actions.DELETE_EXTERNAL_LINK_ERROR,
      error,
    });
    toastr.error("External Link Not Deleted", `${error.error.message}`);
  }
}
